export const GET_TENANT_MANAGEMENT_RECORDS = "TENANT_MANAGEMENT_CREATE"

export const GET_TENANT_RECORDS = "GET_TENANT_RECORDS";

export const TENANT_CREATION_FAILED = "TENANT_CREATION_FAILED"; 

export const DELETE_TENANT = "DELETE_TENANT"; 